import { createContext } from 'react';

import { ModalContextValue } from '../types';

function invalidMethod(..._args: unknown[]): unknown {
    throw new Error('Use CancellationPolicyContext outside of Provider');
}

export const cancellationPolicyContext = createContext<ModalContextValue>({
    isOpen: null!,
    setOpen: invalidMethod,
});
